import {Injectable} from '@angular/core';
import {BehaviorSubject, take} from "rxjs";
import {ApiResponse} from "../shared/model/response/ApiResponse";
import {MessageToastService} from "./message-toast.service";
import {AccountService} from "./api/account.service";
import {AuthenticationService} from "./authentication-service";
import {UserRoleEnum} from "../shared/enums/user-role.enum";

@Injectable({
  providedIn: 'root'
})
export class PrivilegeService {

  _role: BehaviorSubject<string> = new BehaviorSubject<string>(UserRoleEnum.NORMAL);

  constructor(private messageToast: MessageToastService,
              private authService: AuthenticationService,
              private accountService: AccountService) {

  }

  getRole() {
    if (!this._role.value) this.updateRole()
    return this._role.value;
  }

  updateRole() {
    if (this.authService.isAuthenticated()) {
      this.accountService.getRole().pipe(take(1))
        .subscribe({
          next: response => {
            this._role.next(response.data.role)
          },
          error: (error: ApiResponse<any>) => {
            this.messageToast.error(error.message)
            this._role.next(UserRoleEnum.NORMAL)
          }
        })
    }
  }
}
